import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AIChatbot from "./AIChatbot";

export default function Navbar() {
  const [showChatbot, setShowChatbot] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <>
      <nav className="bg-gradient-to-r from-blue-600 to-purple-600 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-8">
              <h1 className="text-2xl font-bold text-white">Cognify</h1>
              <div className="hidden md:flex space-x-4">
                <button className="text-white hover:bg-white/20 px-3 py-2 rounded-md transition">
                  Home
                </button>
                <button className="text-white hover:bg-white/20 px-3 py-2 rounded-md transition">
                  Tasks
                </button>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setShowChatbot(!showChatbot)}
                className="bg-white/20 hover:bg-white/30 text-white px-4 py-2 rounded-lg transition flex items-center space-x-2"
              >
                <span>AI</span>
                <span>AI Chat</span>
              </button>
              <a
                href="https://quantumrudra.replit.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 hover:text-white text-sm transition"
              >
Creator
              </a>
              <button
                onClick={handleLogout}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>
      
      {showChatbot && <AIChatbot onClose={() => setShowChatbot(false)} />}
    </>
  );
}